import * as React from 'react';

interface EstimatorSignatureAffirmationProps {
  onCheck: (checked: boolean) => void;
}

const AFFIRMATION_TEXT = `I have estimated the size of this order based upon the
                    information provided by the customer, and I consent to
                    have my electronic signature used on this order's corresponding estimate forms.`;

export const EstimatorSignatureAffirmation: React.FC<EstimatorSignatureAffirmationProps> = ({ onCheck }) => {
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    onCheck(newChecked);
  };

  return (
    <label className="text-left">
      <input type="checkbox" id="estimator-signature-affirmation" checked={checked} onChange={handleChange} />
      {AFFIRMATION_TEXT}
    </label>
  );
};
